import {message} from 'antd';
import {store} from '../../redux/store';
import {debounce, uniqueId} from 'lodash';
import authActions from '../../redux/auth/actions';
import { getLocalStorageValue } from '../../helpers/utility';
import axios from 'axios';
import { notification } from 'antd';
import { getLanguageMessage } from '../../redux/languageSwitcher/selectors';

const DvNotification = (notificationData) => {
  const type = (notificationData.type)? notificationData.type : 'open';
  notification[type]({
    message: notificationData.titleId ? DvIntlMessages(notificationData.titleId) : notificationData.titleString,
    description: notificationData.messageId && DvIntlMessages(notificationData.messageId) ? DvIntlMessages(notificationData.messageId) : notificationData.messageString
  });
};

const DvIntlMessages = (key) => {
  return getLanguageMessage(store.getState(), key);
};

const showMessageOnce = debounce((errorMsg) => {
  message.error(errorMsg);
}, 2000);

const catchResponseError = ( error ) => {
  let errors = [];
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.status === 403){
      // Expired token      
      store.dispatch(
        authActions.logout()
      );
      cancelAllRequests();
      // let errorMsg = DvIntlMessages("error.expiredSession");
      // message.error(errorMsg);      
      showMessageOnce( DvIntlMessages("error.expiredSession") );
      return { status: -1 };
    } else if (error.response.status === 401){
      // Unauthorized access
      
      store.dispatch(
        authActions.logout()
      );

      cancelAllRequests();

      // let errorKey = (error.response.data.error)?error.response.data.error:"generalError";
      // errors.push(errorKey);
      // showMessageOnce( DvIntlMessages("error.expiredSession") )
      // showMessageOnce( DvIntlMessages("error.expiredSession") );
      return { status: -1 };
    } 
      // Other error(s)
    let errorKey = (error.response.data.error) ? error.response.data.error : "generarlError";
    if (Array.isArray(errorKey)){
      errors = errorKey;
    } else {
      errors.push(errorKey);
    }

  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(['Response Error', error.request]);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log(['Request Failed', error.message]);
  }
  
  return { status: 0, errors:errors };
}

let CancelToken = axios.CancelToken;
let CancelRequest = {};

const DvAxiosRequest = (options, responseCallback) => {  
  const requestUID = uniqueId('request_');
  let headers = {};
  if( typeof options.headers === "undefined"){
    headers = {
      headers : {
        Authorization : 'Bearer ' + getLocalStorageValue('token')
      }
    };
  }
  
  const requestOptions = {
    baseURL: process.env.REACT_APP_SERVER_API_BASE_URL,
    ...headers,
    ...options,
    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      CancelRequest[requestUID] = c;
    })
  }
  
  return axios.request(requestOptions)
    .then(( response ) => {
      delete CancelRequest[requestUID];
      return responseCallback(response);
    })
    .catch((error) => {      
      if (error && error.message === 'Cancel'){
        return {
          status: -1,
          data: null,
        };
      }
      delete CancelRequest[requestUID];
      return catchResponseError(error);
    });
};



const debounceDic = {};
const debounceEx = (key, callback, delay = 1000) => {
  const previous = debounceDic[key];
  if(previous) {
    clearTimeout(previous);
  }

  const next = setTimeout(() => {
    callback();
    delete debounceDic[key];
  }, delay);

  debounceDic[key] = next;
};

const showMessageOnceEx = (messageKey, type, duration) => {
  debounceEx(messageKey, () => {
    notification.open({
      type: type ?? 'error',
      duration : duration ?? 4.5,
      message: DvIntlMessages(messageKey)
    });
  }, 1000);
};
const catchResponseErrorEx = ( reason ) => {
  if (reason.response) {
    if (reason.response.status === 403) {
      if(reason.response.data.error === "invalid-persmissions") {
        showMessageOnceEx("error.invalidPermissions");
      }
      else {
        store.dispatch(authActions.logout());
        cancelAllRequests();
        showMessageOnceEx("error.expiredSession");
      }
    }
    else if (reason.response.status === 401) {
      showMessageOnceEx("error.unauthorizedForAction");
    } 
    else if (reason.response.status === 503) {
      showMessageOnceEx("error.maintenance");
    } else if (reason.response.status === 404) {
      showMessageOnceEx("error.notFound");
    }
  }
  return reason;
}

const DvAxiosRequestEx = (options) => {  
  const requestUID = uniqueId('request_');
  let headers = {};
  if (typeof options.headers === "undefined"){
    headers = {
      headers : {
        Authorization : 'Bearer ' + getLocalStorageValue('token')
      }
    };
  }
  else {
    headers = {
      headers: options.headers
    };
  }
  const requestOptions = {
    baseURL: process.env.REACT_APP_SERVER_API_BASE_URL,
    ...headers,
    ...options,
    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      CancelRequest[requestUID] = c;
    })
  };  
  return axios.request(requestOptions)
    .then(response => {
      delete CancelRequest[requestUID];
      return response;
    }, error => {
      if (error && error.message === 'Cancel'){
        return Promise.reject();
      }
      delete CancelRequest[requestUID];
      return options.skipNotifications
        ? Promise.reject(error)
        : Promise.reject(catchResponseErrorEx(error));
    });
};

const cancelAllRequests = () => {
  for (let requestUID in CancelRequest) {
    const cancel = CancelRequest[requestUID];
    cancel('Cancel');
  }
  CancelRequest = {};
};

const DVConvertFiltersToGetParams = (objectParams) => {
  let getParams = '';
  
  for (const paramKey in objectParams) {
		const paramValue  = objectParams[paramKey];

		if (paramKey === "facet_filter") {
			getParams += normalizeFacetFilters(paramValue);
		}
    else if (Array.isArray(paramValue)) {
      for ( let itemKey in paramValue ) {
        getParams += "&" + paramKey + "[]=" + paramValue[itemKey];
      }
    } else {
      getParams += "&" + paramKey + "=" + paramValue;
    }
    
  }

  return getParams;
}

const normalizeFacetFilters = facetFilters => {
	let normalized = null;
	for (const [key, filters] of Object.entries(facetFilters)) {
		if (key === "cancer_type") {
			//filters can be either array or a string
			//since it can be an array of cancer types ids
			//or if its a manual cancer type just the manual keyword

			const filtersQueryString = Array.isArray(filters)
				? filters.join("|")
				: filters;
			
				normalized = `&${key}=` + encodeURIComponent(filtersQueryString);
		}
	}
	return normalized;
};

export {
  DvNotification, DvIntlMessages, catchResponseError, 
  DvAxiosRequest, cancelAllRequests, DVConvertFiltersToGetParams,
  DvAxiosRequestEx, catchResponseErrorEx,
};
